import logo from './logo.svg';
import { Col, Row, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useEffect, useState } from 'react';
import './App.scss';
import Points from './Points';
import AddUser from './AddUser';

function App() {
  const [users, setUser] = useState([]);
  const [winner, setWinner] = useState(null);
  const [activeUser, setActiveUser] = useState();
  const [isUserModalActive, setIsUserModalActive] = useState(null);
  const [usersPoints, setUsersPoints] = useState({});

  useEffect(() => {
    if (users.length > 0) setActiveUser(users[users.length - 1]);
  }, [users]);

  useEffect(() => {
    // Calc which user has the most points
    let topScore = 0;
    let tempWinner = null;

    Object.entries(usersPoints).forEach(([name, points]) => {
      let sum = 0;

      Object.values(points).forEach((data) => {
        sum += data.value;
      });

      if (sum > topScore) {
        topScore = sum;
        tempWinner = { name: name, points: sum };
      }
      else if (sum === topScore) {
        topScore = sum;
        tempWinner = { name: 'BRAK', points: sum };
      }
    });

    tempWinner && setWinner({ name: tempWinner.name, points: topScore });
  }, [usersPoints]);

  const handleChoose = (user) => {
    setActiveUser(user);
  }

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdown = () => setIsDropdownOpen((prevState) => !prevState);

  return (
    <div className="app">
      {isUserModalActive && <AddUser setIsUserModalActive={setIsUserModalActive} setUser={setUser} users={users} setPointsStrucutre={setUsersPoints} pointsStructure={usersPoints} />}
      <Row className='justify-content-center'>
        <Col xs={12}>
          <h1 className='text-center mb-3'>jedliSystem</h1>
        </Col>
        <Col xs={'auto'} className={'my-2'}>
          <Button onClick={() => { setIsUserModalActive(true) }}>Dodaj uzytkownika</Button>
        </Col>
        <Col xs={'auto'} className={'my-2'}>
          <Dropdown isOpen={isDropdownOpen} toggle={handleDropdown}>
            <DropdownToggle caret>Wybierz gracza</DropdownToggle>
            <DropdownMenu>
              {users.map((user) => (
                <DropdownItem
                  key={user.name}
                  onClick={() => handleChoose(user)}
                >
                  {user.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </Col>
        {winner &&
          <Col xs={'12'} className='text-center mt-3'>
            <div>ZWYCIĘZCA:</div>
            <div>{winner.name} ({winner.points} pkt)</div>
          </Col>
        }
        <Col xs={'12'} className='text-center mt-3'>
          <div>Aktywny uzytownik:</div>
          <div><b>{activeUser ? activeUser.name : 'BRAK'}</b></div>
        </Col>
        <Col xs={12}>
          {activeUser && <Points key={activeUser.name} user={activeUser} usersPoints={usersPoints} setUserPoints={setUsersPoints} />}
        </Col>
      </Row>
    </div >
  );
}

export default App;
